import { render, staticRenderFns } from "./capabilities.vue?vue&type=template&id=5d1cfbb4&scoped=true&"
import script from "./capabilities.vue?vue&type=script&lang=js&"
export * from "./capabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1cfbb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1cfbb4')) {
      api.createRecord('5d1cfbb4', component.options)
    } else {
      api.reload('5d1cfbb4', component.options)
    }
    module.hot.accept("./capabilities.vue?vue&type=template&id=5d1cfbb4&scoped=true&", function () {
      api.rerender('5d1cfbb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains/fields/capabilities.vue"
export default component.exports